import type { ServiceResponse } from "./api.types";
import { privateAPI } from "./axios";

export const sendForgotPasswordEmail = async (email: string) => {
  const { data } = await privateAPI.post<ServiceResponse<{ message: string }>>(
    "/users/forgot-password",
    { email },
  );
  return data.data;
};

export const resetPassword = async ({
  token,
  password,
}: {
  token: string;
  password: string;
}) => {
  const { data } = await privateAPI.put<
    ServiceResponse<{ token: string; password: string }>
  >("/users/reset-password", { token, password });
  return data.data;
};
